import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetch_app_configs, preview_public_config, update_app_config } from './api';
import type { AppClient, AppPlatform, UpdateAppConfigInput } from './types';

const CONFIGS_KEY = ['admin', 'app-configs'] as const;

export function use_app_configs() {
  return useQuery({ queryKey: CONFIGS_KEY, queryFn: fetch_app_configs });
}

export function use_update_app_config() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { app: AppClient; platform: AppPlatform; input: UpdateAppConfigInput }) =>
      update_app_config(vars.app, vars.platform, vars.input),
    onSuccess: () => qc.invalidateQueries({ queryKey: CONFIGS_KEY }),
  });
}

/**
 * The tester. A mutation rather than a query because it is an action an operator takes on
 * purpose — nothing should re-fetch it in the background, and each press should be a fresh
 * answer from the server rather than a cached one.
 */
export function use_preview_config() {
  return useMutation({
    mutationFn: (vars: { app: AppClient; platform: AppPlatform; build: number }) =>
      preview_public_config(vars.app, vars.platform, vars.build),
  });
}
